import { render, staticRenderFns } from "./RevenueTabs.vue?vue&type=template&id=70a5dedd&"
import script from "./RevenueTabs.vue?vue&type=script&lang=js&"
export * from "./RevenueTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports